import { ZusatzoptionItem } from '@ps20-frontend/frontend-models';

export enum ZusatzoptionenNameVHVEnum {
  ELEMENTAR = 'ELEMENTAR',
}

export interface ZusatzoptionItemVHV extends ZusatzoptionItem {
  name: ZusatzoptionenNameVHVEnum | string;
}
